






















































































import {ScrollButton} from "wings-ui-components";
import { Component } from "vue-property-decorator";
import { ManagementTemplatesItem } from "@/store/mail_notify/management_templates/types";
import { Getter } from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import MNManagementTemplatesFilter from "@/components/MailNotify/TemplateManagement/MNManagementTemplatesFilter.vue";

@Component({ components: {MNManagementTemplatesFilter, ScrollButton } })
export default class MNManagementTemplates extends BaseItemsPage<ManagementTemplatesItem> {

  @Getter("managementTemplates") managementTemplatesResponse: any;

  private is_show_filter = false;
  currentSort = "tmpl";
  currentSortOrder = "desc";
  tableFields = ['tmpl', 'service_provider_name', 'mn_service_name', 'status_id', 'description'];

  getData(): any {
    return this.managementTemplatesResponse;
  }
}
